module.exports = ".secondline {\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.4);\n  margin-top: -5px;\n  font-weight: 600; }\n"